import * as React from 'react';
const DhlIcon = props => {
  const fill = props.color ? props.color : '#fff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="spedizionieri_icon"
      data-name="spedizionieri icon"
      viewBox="0 0 1478.64 209.3"
      {...props}
    >
      <defs>
        <style>{`.cls-1{fill:${fill};fill-rule:evenodd}`}</style>
      </defs>
      <path
        d="m259.78 0-47.09 64.33h257.32c12.93 0 12.93 4.92 6.46 13.54s-17.24 24.01-24.01 32.93c-3.39 4.62-9.23 12.62 10.47 12.62H568.2l31.7-42.48c19.39-26.16 1.54-80.95-67.41-80.95H259.78Z"
        className="cls-1"
      />
      <path
        d="m193.6 209.3 94.8-128.97h117.89c12.93 0 12.93 4.92 6.46 13.54-6.46 8.62-17.54 23.7-24.01 32.63-3.39 4.62-9.23 12.62 10.77 12.62h157.9c-13.24 17.85-55.71 69.87-132.04 69.87l-231.77.31ZM736.86 139.12l-51.4 69.87H549.72l51.4-69.87h135.74ZM944.93 123.43H612.82L703.62 0h135.73l-52.01 70.79h60.63L899.99 0h135.74l-90.8 123.43zM933.23 139.43l-51.4 69.87H746.09l51.4-69.87h135.74ZM0 166.82h199.76l-10.77 15.09H0v-15.09zM0 139.43h220.07L209.3 154.2H0v-14.77zM0 194.53h179.44l-10.77 14.77H0v-14.77zM1478.64 181.91h-199.45l11.08-15.09h188.37v15.09zM1478.64 209.3h-219.45l10.77-14.77h208.68v14.77zM1310.59 139.43h168.05v14.77h-179.13l11.08-14.77zM1223.48 0l-90.8 123.43H988.94L1079.74 0h143.74ZM977.25 139.43s-9.85 13.54-14.77 20.01c-16.93 23.08-1.85 49.86 53.56 49.86h217.92l51.4-69.87h-308.1Z"
        className="cls-1"
      />
    </svg>
  );
};
export default DhlIcon;
